import React from "react";

const Options = ({ options = [], selectedOptions, setSelectedOptions }) => {
  return (
    <ul className="options">
      {(options || []).map((item) => (
        <li className="option">
          <div>
            <p>
              <strong>{item.name}</strong>
              <span>{item.isRequired ? "1개 선택 필수" : "선택 사항"}</span>
            </p>
            <span className={`tag ${item.isRequired ? "required" : "optional"}`}>
              {item.isRequired ? "필수" : "선택"}
            </span>
          </div>
          <ul className="optionList">
            {(item?.options || []).map((option) => (
              <li className="optionItem">
                <div>
                  <label htmlFor={option.id}>
                    <input
                      type="radio"
                      id={option.id}
                      name={`option-${item?.id || item?.name}`}
                      checked={selectedOptions[item?.id || item?.name]?.id === option.id}
                      onChange={() =>
                        setSelectedOptions((prev) => ({
                          ...prev,
                          [item?.id || item?.name]: option,
                        }))
                      }
                      disabled={
                        option.quantity === 0 ||
                        option.status === "SOLDOUT" ||
                        (option.quantity !== -1 && option.quantity < option?.quantity)
                      }
                    />
                    <span className="checkmark"></span>
                    <span className="optionName">
                      {option.value}{" "}
                      {option.quantity !== -1 ? `(재고 ${formatQuantity(option.quantity)})` : ""}
                      {option.status === "SOLDOUT" ? "(품절)" : ""}
                    </span>
                  </label>
                </div>
                <span className="price">{formatNumber(option.addPrice)}원</span>
              </li>
            ))}
          </ul>
        </li>
      ))}
    </ul>
  );
};

export default Options;
